// Material Kit 2 React components
import MKTypography from "components/MKTypography";

const date = new Date().getFullYear();

export default {
  menus: [
    {
      name: "property",
      items: [
        { name: "home", route: "/" },
        { name: "gallery", route: "/gallery" },
        { name: "car rentals", route: "/car-rentals" },
        { name: "book now", route: "/booking" },
      ],
    },
    {
      name: "information",
      items: [
        { name: "about", route: "/about" },
        { name: "house rules", href: "/booking#rules" },
        { name: "location", href: "/#location" },
        { name: "reviews", href: "/#reviews" },
      ],
    },
    {
      name: "contact",
      items: [
        { name: "email us", href: "mailto:croceanfrontrentals@gmail.com" },
        { name: "airbnb listing", href: "https://www.airbnb.com/rooms/9803481" },
        { name: "vrbo listing", href: "https://www.vrbo.com/4631717" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date}{" "}
      <MKTypography component="a" href="/" variant="button" fontWeight="regular">
        Stalley Beach House
      </MKTypography>
      .
    </MKTypography>
  ),
};
